import dayjs from "../dayjs";
import { DATE_STRING } from "../model/busRoute";
import { normaliseDate } from "./routes-lib";

export const formatToDateString = (date) => {
    if(!date) {
        return null;
    }
    if(typeof date === 'string') {
        return dayjs(date).format(DATE_STRING);
    }
    return date.format?.(DATE_STRING) || date;
}


export const parseSecondsToDuration = (seconds) => {
    if(!seconds) {
        return { days: 0, hours: 0, minutes: 0 };
    }
    let days = Math.floor(seconds / 86400);
    let remainingSeconds = seconds % 86400;
    let hours = Math.floor(remainingSeconds / 3600);
    let minutes = Math.ceil((remainingSeconds % 3600) / 60);
    // Handle case where minutes round up to 60
    if (minutes === 60) {
        hours += 1;
        minutes = 0;
    }
    // Handle case where hours round up to 24
    if (hours === 24) {
        days += 1;
        hours = 0;
    }
    return { days, hours, minutes };
}

export const checkIfDatesMatch = (dates1, dates2) => {
    // check if day, month, year are the same
    return normaliseDate(dates1).format(DATE_STRING) === normaliseDate(dates2).format(DATE_STRING);
}

export const getUniqueDates = (dates) => {
    const arrayOfDateStrings = dates.map(date => normaliseDate(date)?.format(DATE_STRING));
    return [...new Set(arrayOfDateStrings)].map(date => normaliseDate(date));
}